import { Routes } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { Oauth2CallbackComponent } from './components/oauth2-callback/oauth2-callback.component';
import { GuestGuard } from '../shared/guards/guest.guard';
import { LoggedInGuard } from '../shared/guards/loggedin.guard';
import { routeNames } from '../../shared/route-names';

export const routes: Routes = [
  {
    path: routeNames.auth,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [GuestGuard],
      },
      {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [LoggedInGuard],
      },
    ],
  },
  {
    path: 'oauth2/callback',
    component: Oauth2CallbackComponent,
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [GuestGuard],
  },
];
